module.exports = __webpack_public_path__ + "fonts/Poppins-ExtraLight.86a2f13e.ttf";